import classes from './standardTimeLegend.module.scss';

export const useStandardTimeLegend = () => {
  const getDate = () => {
    const date = new Date();
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}-${year}`;
  };

  const handlePrint = () => {
    const container = document.querySelector(`.${classes.container}`);
    if (!container) {
      alert('Container not found!');
      return;
    }

    // Copy all <style> and <link rel="stylesheet"> tags
    let styles = '';
    document.querySelectorAll('style, link[rel="stylesheet"]').forEach(node => {
      styles += node.outerHTML;
    });

    // Copy <base> tag for relative URLs (images, fonts, etc.)
    const base = document.querySelector('base');
    const baseTag = base ? base.outerHTML : '';

    // Copy all <link rel="preconnect"> and <link rel="preload"> for fonts
    let fontLinks = '';
    document.querySelectorAll('link[rel="preconnect"], link[rel="preload"]').forEach(node => {
      fontLinks += node.outerHTML;
    });

    // Clone the container for printing
    const clone = container.cloneNode(true) as HTMLElement;
    const printWindow = window.open('', '', 'width=900,height=650');
    if (!printWindow) {
      alert('Could not open print window!');
      return;
    }

    printWindow.document.write(`
          <html>
            <head>
              ${baseTag}
              <title>Print</title>
              ${fontLinks}
              ${styles}
              <style>
                @page { size: auto; margin: 10mm; }
                body { background: white !important; }
                @media print {
                    #print-btn { display: none !important; }
                }
              </style>
            </head>
            <body>
              ${clone.outerHTML}
            </body>
          </html>
        `);

    printWindow.document.close();
    printWindow.focus();

    printWindow.onload = function () {
      setTimeout(function () {
        printWindow.print();
        printWindow.close();
      }, 700);
    };
  };

  return {
    handlePrint,
    getDate
  };
};
